// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".module-container[data-v-571e298e] {\n  border-radius: 12px;\n}\n.module-container.module-box-shadow[data-v-571e298e] {\n  box-shadow: 0 12px 17px rgba(21, 29, 63, 0.03) !important;\n}\n.module-container .indicator[data-v-571e298e] {\n  border-left: 4px solid var(--v-primary-base);\n  height: 24px;\n}", ""]);
// Exports
module.exports = exports;
